// While a share runs, leaving the page asks first (solution sharing plan, stage 7): in-app navigation
// through the router's Prompt, closing or reloading the tab through beforeunload.
import React, { useEffect } from "react";
import { Prompt } from "react-router-dom";

export const LEAVE_MESSAGE = "A share is running. Leave anyway? It continues on the server, and the roles it reached keep the solution.";

export default function LeaveGuard({ active }) {
  useEffect(() => {
    if (!active) return undefined;
    const ask = (e) => {
      e.preventDefault();
      e.returnValue = LEAVE_MESSAGE;
      return LEAVE_MESSAGE;
    };
    window.addEventListener("beforeunload", ask);
    return () => window.removeEventListener("beforeunload", ask);
  }, [active]);
  return <Prompt when={!!active} message={LEAVE_MESSAGE} />;
}
